import { render } from "./SimpleTableCell.vue?vue&type=template&id=5a5a775e"
import script from "./SimpleTableCell.vue?vue&type=script&lang=js"
export * from "./SimpleTableCell.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__